/* eslint-disable @sas/i18n/jsx-to-localize */
export const basicColors = ['#000000',
// Black
'#545B66',
// Deep gray
'#B0B7C2',
// Gray
'#E9ECEF',
// Light gray
'#FFFFFF',
// White
'#2470AD',
// Dark blue
'#2C8AD6',
// Deep blue
'#33A3FF',
// Blue
'#7DC3FC',
// Light blue
'#C7E3F9',
// Pale blue
'#434FAC',
// Dark purple
'#585CD6',
// Deep purple
'#6D69FF',
// Purple
'#ACB0FF',
// Light purple
'#D2D4FF',
// Pale purple
'#17785F',
// Dark green
'#16976D',
// Deep green
'#15B57B',
// Green
'#43D09D',
// Light green
'#71EBBF',
// Pale green
'#84414B',
// Dark red
'#B14C51',
// Deep red
'#DD5757',
// Red
'#E99596',
// Light red
'#F4D3D4',
// Pink
'#985B30',
// Dark orange
'#CC6F2A',
// Deep orange
'#FF8224',
// Orange
'#FFAE70',
// Light orange
'#FFD9BC',
// Pale orange
'#98863C',
// Dark yellow
'#CCA937',
// Deep yellow
'#FFCC32',
// Yellow
'#FCDD7C',
// Light yellow
'#F9EDC6' // Pale yellow
];

export const basicColorsNameMap = {
  '#000000': 'Black',
  '#545B66': 'Deep gray',
  '#B0B7C2': 'Gray',
  '#E9ECEF': 'Light gray',
  '#FFFFFF': 'White',
  '#2470AD': 'Dark blue',
  '#2C8AD6': 'Deep blue',
  '#33A3FF': 'Blue',
  '#7DC3FC': 'Light blue',
  '#C7E3F9': 'Pale blue',
  '#434FAC': 'Dark purple',
  '#585CD6': 'Deep purple',
  '#6D69FF': 'Purple',
  '#ACB0FF': 'Light purple',
  '#D2D4FF': 'Pale purple',
  '#17785F': 'Dark green',
  '#16976D': 'Deep green',
  '#15B57B': 'Green',
  '#43D09D': 'Light green',
  '#71EBBF': 'Pale green',
  '#84414B': 'Dark red',
  '#B14C51': 'Deep red',
  '#DD5757': 'Red',
  '#E99596': 'Light red',
  '#F4D3D4': 'Pink',
  '#985B30': 'Dark orange',
  '#CC6F2A': 'Deep orange',
  '#FF8224': 'Orange',
  '#FFAE70': 'Light orange',
  '#FFD9BC': 'Pale orange',
  '#98863C': 'Dark yellow',
  '#CCA937': 'Deep yellow',
  '#FFCC32': 'Yellow',
  '#FCDD7C': 'Light yellow',
  '#F9EDC6': 'Pale yellow'
};
//# sourceMappingURL=BasicColorPallete.js.map